import React from 'react';

import T from '../../../i18n/i18n';
import { Notification } from './Notification.styles';

export default ({type, children}) => {

    return <Notification>
        { type === 'enter' && <>{children} <T value="chat.enter" /></>}
        { type === 'leave' && <>{children} <T value="chat.leave" /></>}
    </Notification>

};